module.exports = __webpack_public_path__ + "@/assets/img/zoom-minus.d7a7655b.svg";